import React from 'react';
import ReactDOM from 'react-dom';

import FilterContainer from '../../product-filter/components/FilterContainer';
import FilterCategory from '../../product-filter/components/FilterCategory';

import SortList from '../../product-filter/sort-type/sort';

// Sorts
const newest = {
    label: i18njs["Resource.ProjectorFilterSortNewest"],
    value: 'newest',
    sort: (products) => {
        if(!Array.isArray(products)){
            console.warn("Products should be an array. No sort has been applied");
            return products;
        }
        return [...products].sort((a, b) => b.EpochTimeSeconds - a.EpochTimeSeconds);
    }
}
    
const relevance = {
    label: i18njs["Resource.ProjectorFilterSortRelevance"],
    value: 'relevance',
    sort: (products) => {
        if (!Array.isArray(products)) {
            console.warn("Products should be an array");
            return products;
        }
        return [...products].sort((a, b) => b.ProductScore - a.ProductScore);
            
    }
}
    
const sortList = new SortList([newest, relevance]);
const htmlElement = document.getElementById("filteredPage");

ReactDOM.render(
    <FilterContainer apiUrl={htmlElement.dataset.apiurl} sortList={sortList} defaultSort={relevance}
        localisedStrings={{
            filter: i18njs["Resource.ProjectorFilterFilter"],
            sort: i18njs["Resource.ProjectorFilterSort"],
            items: i18njs["Resource.ItemsLCase"],
            NoProductsAvailable: i18njs["Resource.NoProductsAvailable"]
        }}
    >

        <FilterCategory heading={i18njs["Resource.viewByCategory"]} dataPoint={"Categories"} type={"checkbox"} />
        <FilterCategory heading={i18njs["Resource.DiagonalMeasure"]} dataPoint={"DiagonalViewingSizeInch"} type={"range"} step={1} />
        <FilterCategory heading={i18njs["Resource.AspectRatio"]} dataPoint={"NativeAspectRatio"} type={"checkbox"} />
        <FilterCategory heading={i18njs["Resource.ProjectorFilterHeadingWeight"]} dataPoint={"WeightKg"} type={"range"} collapsed units={"kg"} />
    </FilterContainer>,
    document.getElementById("filteredPage")
);